import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { DataService } from '../../app/configure/service/deviceservice';
function useTokenNavigation(isDomainAvailable) {
    var _a;
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dataService = new DataService();
    const signageToken = (_a = searchParams.get('token')) === null || _a === void 0 ? void 0 : _a.split('?')[0];
    const [token, setToken] = useState('');
    useEffect(() => {
        console.log('useTokenNavigation', signageToken);
        const viewToken = signageToken
            ? signageToken
            : dataService.getDeviceToken();
        dataService.setDeviceToken(viewToken);
        setToken(viewToken);
    }, [signageToken]);
    useEffect(() => {
        console.log('useTokenNavigation', token, isDomainAvailable);
        // Skip navigation for cache test page
        if (location.pathname === '/cache-test') {
            console.log('Skipping navigation for cache test page');
            return;
        }
        if (token && isDomainAvailable) {
            console.log('navigating to home');
            navigate('/home', { state: { token } });
        }
    }, [token, isDomainAvailable, location.pathname]);
    return null;
}
export default useTokenNavigation;
